'use client';

import { type ReactNode } from 'react';
import { ChevronLeft } from 'lucide-react';
import { IconButton } from '@zillow/constellation-10';
import { LucideIcon } from '@/src/components/LucideIcon';
import {
  listingActionGlass,
  listingActionGlassForeground,
} from '@/src/components/features/listings/ListingActionCluster/listingActionCluster.styles';
import * as styles from './desktopStickyHeader.styles';

type DesktopStickyHeaderProps = {
  backHref: string;
  onBackClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  backLabel?: string;
  backAriaLabel?: string;
  /** Desktop gallery-overlay actions. */
  actions?: ReactNode;
};

export const DesktopStickyHeader = ({
  backHref,
  onBackClick,
  backLabel,
  backAriaLabel,
  actions,
}: DesktopStickyHeaderProps) => {
  const label = backLabel ?? 'Back to search';
  const ariaLabel = backAriaLabel ?? backLabel ?? 'Back to search results';

  const backControl = (
    <IconButton
      asChild
      shape="circle"
      tone="neutral"
      emphasis="bare"
      size="sm"
      title={label}
      aria-label={ariaLabel}
      css={listingActionGlass.raw({ layout: 'control' })}
    >
      <a
        href={backHref}
        onClick={onBackClick}
        title={label}
        aria-label={ariaLabel}
        data-testid="link-back-to-search-results"
      >
        <LucideIcon icon={ChevronLeft} css={listingActionGlassForeground} />
      </a>
    </IconButton>
  );

  return (
    <header className={styles.desktopHeader}>
      <div className={styles.desktopHeaderColumns}>
        <div className={styles.desktopHeaderLeft}>{backControl}</div>

        <div className={styles.desktopHeaderRight}>{actions}</div>
      </div>
    </header>
  );
};
